<script>
  import { onMount } from 'svelte'
  import {
    //AudioWave,
    BeforeAfter,
    Block,
    Bullets,
    //Carousel,
    Chapters,
    //CodeBlock,
    //Datawrapper,
    //Drawer,
    //InfoBox,
    GraphTitle,
    Heading,
    //ImageSlider,
    //Newsletter,
    //Panorama,
    Paragraph,
    //Parallax,
    //Paywall,
    Photo,
    PhotoGrid,
    //PhotoZoomies,
    Pullout,
    Quote,
    MoreArticles,
    ScrollyST,
    SectionBreaker,
    SvgFolderST,
    //Timeline,
    Video,
  } from '@st-graphics/graphics-components'

  import Collapsible from './Collapsible.svelte'

  import WhatsInAScrolly from '$components/Project/Body/WhatsInAScrolly.svelte'
  import NamesByYear from '$components/Project/NamesByYearScrolly/NamesByYear.svelte'

  let { sections, id = undefined, class: className = '' } = $props()

  let scrollY = $state(0)
  let innerHeight = $state(0)
  let condoOffsetTop = $state(0)
  let articleBodyEl = $state(null)

  onMount(() => {
    let frame
    let lastPastCondo = null

    const checkPosition = () => {
      const condoEl = articleBodyEl?.querySelector('.condo')
      if (condoEl && typeof document !== 'undefined') {
        const rect = condoEl.getBoundingClientRect()
        // Trigger when condo section is actively in the viewport
        const isVisible =
          rect.top < window.innerHeight * 0.8 && rect.bottom > window.innerHeight * 0.2

        if (isVisible !== lastPastCondo) {
          document.documentElement.style.setProperty(
            '--body-background-color',
            isVisible ? '#01268C' : '#31499c',
          )
          lastPastCondo = isVisible
        }
      }
      frame = requestAnimationFrame(checkPosition)
    }

    // Small delay to ensure rendering before first check
    setTimeout(() => {
      frame = requestAnimationFrame(checkPosition)
    }, 100)

    return () => {
      if (frame) cancelAnimationFrame(frame)
      document.documentElement.style.removeProperty('--body-background-color')
    }
  })

  const components = {
    //audiowave: { component: AudioWave, layout: 'inline' },
    beforeafter: { component: BeforeAfter, layout: 'container' },
    bullets: { component: Bullets, layout: 'inline' },
    //carousel: { component: Carousel, layout: 'container' },
    chapters: { component: Chapters, layout: 'inline' },
    //codeblock: { component: CodeBlock, layout: 'inline' },
    //datawrapper: { component: Datawrapper, layout: 'inline' },
    //drawer: { component: Drawer, layout: 'inline' },
    //infobox: { component: InfoBox, layout: 'inline' },
    graphtitle: { component: GraphTitle, layout: 'inline' },
    heading: { component: Heading, layout: 'inline' },
    //imageslider: { component: ImageSlider, layout: 'inline' },
    //newsletter: { component: Newsletter, layout: 'inline' },
    morearticles: { component: MoreArticles, layout: 'inline' },
    //panorama: { component: Panorama, layout: 'container' },
    paragraph: { component: Paragraph, layout: 'inline' },
    //parallax: { component: Parallax, layout: 'immersive' },
    //paywall: { component: Paywall, layout: 'inline' },
    photo: { component: Photo, layout: 'spread' },
    photogrid: { component: PhotoGrid, layout: 'container' },
    //photozoomies: { component: PhotoZoomies, layout: 'fullwidth' },
    pullout: { component: Pullout, layout: 'inline' },
    quote: { component: Quote, layout: 'inline' },
    sectionbreaker: { component: SectionBreaker, layout: 'inline' },
    scrollyst: { component: ScrollyST, layout: 'container' },
    //timeline: { component: Timeline, layout: 'inline' },
    svgfolderst: { component: SvgFolderST, layout: 'container' },
    videocontent: { component: Video, layout: 'spread' },

    // Map custom components.
    whatsinascrolly: { component: WhatsInAScrolly, layout: 'immersive' },
    namesbyyearscrolly: { component: NamesByYear, layout: 'immersive' },
  }
</script>

<svelte:window bind:scrollY bind:innerHeight />

<div {id} class={`article-body ${className}`} bind:this={articleBodyEl}>
  {#each sections as { id: sectionId, class: sectionClass, background: sectionBg, blocks }}
    <section id={sectionId} class={sectionClass} style:background={sectionBg}>
      <Collapsible className={sectionClass}>
        {#each blocks as { id: blockId, class: blockClass, background: blockBg, type, layout, ...props }}
          <Block
            id={blockId}
            class={blockClass}
            background={blockBg}
            {type}
            layout={layout || components[type]?.layout}
          >
            {@const SvelteComponent = components[type]?.component}
            {#if SvelteComponent}
              <SvelteComponent {...props} />
            {/if}
          </Block>
        {/each}
      </Collapsible>
    </section>
  {/each}
</div>

<style lang="scss">
  section {
    margin: px-to-rem(25) 0 px-to-rem(20);

    @media (min-width: $screen-md) {
      margin-top: px-to-rem(20);
    }
  }
</style>
